import {FC, Fragment, useEffect} from 'react';
import {Helmet} from 'react-helmet-async';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import {useApp} from '@/providers/components/appProvider';

import Themeprimarycolor, * as switcherdata from './switcherdata/switcherdata';
import {ThemeChanger} from '../../../lib/reducers/themeSlice';

const Switcher: FC = () => {
  const {theme} = useApp();
  useEffect(() => {
    switcherdata.LocalStorageBackup(ThemeChanger);
  }, []);
  const customStyles: any = `${theme.colorPrimaryRgb != '' ? `--primary-rgb: ${theme.colorPrimaryRgb}` : ''};
  ${theme.colorPrimary != '' ? `--primary: ${theme.colorPrimary}` : ''};
  ${theme.darkBg != '' ? `--dark-bg: ${theme.darkBg}` : ''};
  ${theme.bodyBg != '' ? `--body-bg: ${theme.bodyBg}` : ''};
  ${theme.inputBorder != '' ? `--input-border: ${theme.inputBorder}` : ''};
  ${theme.Light != '' ? `--light: ${theme.Light}` : ''};`;

  return (
    <Fragment>
      <Helmet>
        <html
          dir={theme.dir}
          className={theme.class}
          data-header-styles={theme.dataHeaderStyles}
          data-vertical-style={theme.dataVerticalStyle}
          data-nav-layout={theme.dataNavLayout}
          data-menu-styles={theme.dataMenuStyles}
          data-toggled={theme.toggled}
          data-nav-style={theme.dataNavStyle}
          data-hor-style={theme.horStyle}
          data-page-style={theme.dataPageStyle}
          data-width={theme.dataWidth}
          data-menu-position={theme.dataMenuPosition}
          data-header-position={theme.dataHeaderPosition}
          data-icon-overlay={theme.iconOverlay}
          data-bg-img={theme.bgImg}
          data-icon-text={theme.iconText}
          //Styles
          style={customStyles}
        ></html>
      </Helmet>
      <div id="hs-overlay-switcher" className="hs-overlay ti-offcanvas ti-offcanvas-right hidden" tabIndex={-1}>
        <div className="ti-offcanvas-header relative z-10">
          <h5 className="ti-offcanvas-title">Switcher</h5>
          <button
            type="button"
            className="ti-btn flex-shrink-0 p-0 text-defaulttextcolor transition-none hover:text-gray-700 focus:ring-gray-400 focus:ring-offset-white dark:text-defaulttextcolor/70 dark:hover:text-white/80 dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
            data-hs-overlay="#hs-overlay-switcher"
          >
            <span className="sr-only">Close modal</span>
            <i className="ri-close-circle-line text-lg leading-none"></i>
          </button>
        </div>
        <div className="ti-offcanvas-body relative z-10 !h-auto !border-b !p-0 dark:border-white/10">
          <div className="flex rtl:space-x-reverse" aria-label="Tabs" role="tablist">
            <button
              type="button"
              className="active -mb-px w-full rounded-none border-0 bg-white !px-4 !py-2 text-center text-defaultsize font-semibold text-defaulttextcolor hover:text-gray-700 hs-tab-active:border-b-transparent hs-tab-active:bg-success/20 hs-tab-active:text-success dark:border-white/10 dark:bg-bodybg dark:text-defaulttextcolor/70 dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:bg-success/20 dark:hs-tab-active:text-success"
              id="switcher-item-1"
              data-hs-tab="#switcher-1"
              aria-controls="switcher-1"
              role="tab"
            >
              Theme Style
            </button>
            <button
              type="button"
              className="-mb-px w-full rounded-none border-0 bg-white !px-4 !py-2 text-center text-defaultsize font-semibold text-defaulttextcolor hover:text-gray-700 hs-tab-active:border-b-transparent hs-tab-active:bg-success/20 hs-tab-active:text-success dark:border-white/10 dark:bg-bodybg dark:text-defaulttextcolor/70 dark:hover:text-gray-300 dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:bg-success/20 dark:hs-tab-active:text-success"
              id="switcher-item-2"
              data-hs-tab="#switcher-2"
              aria-controls="switcher-2"
              role="tab"
            >
              Theme Colors
            </button>
          </div>
        </div>
        <div className="ti-offcanvas-body" id="switcher-body">
          <div id="switcher-1" role="tabpanel" aria-labelledby="switcher-item-1" className="">
            <div className="">
              <p className="switcher-style-head">Theme Color Mode:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="theme-style"
                    className="ti-form-radio"
                    id="switcher-light-theme"
                    checked={theme.class != 'dark'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Light(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-light-theme"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Light
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="theme-style"
                    className="ti-form-radio"
                    id="switcher-dark-theme"
                    checked={theme.class == 'dark'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Dark(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-dark-theme"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Dark
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Directions:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="direction"
                    className="ti-form-radio"
                    id="switcher-ltr"
                    checked={theme.dir == 'ltr'}
                    onChange={_e => {}}
                    onClick={() => {
                      switcherdata.Ltr(ThemeChanger);
                    }}
                  />
                  <label
                    htmlFor="switcher-ltr"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    LTR
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="direction"
                    className="ti-form-radio"
                    id="switcher-rtl"
                    checked={theme.dir == 'rtl'}
                    onChange={_e => {}}
                    onClick={() => {
                      switcherdata.Rtl(ThemeChanger);
                    }}
                  />
                  <label
                    htmlFor="switcher-rtl"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    RTL
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Navigation Styles:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="navigation-style"
                    className="ti-form-radio"
                    id="switcher-vertical"
                    checked={theme.dataNavLayout == 'vertical'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Vertical(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-vertical"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Vertical
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="navigation-style"
                    className="ti-form-radio"
                    id="switcher-horizontal"
                    checked={theme.dataNavLayout == 'horizontal'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.HorizontalClick(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-horizontal"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Horizontal
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Navigation Menu Style:</p>
              <div className="switcher-style grid grid-cols-2 gap-2">
                <div className="flex">
                  <input
                    type="radio"
                    name="navigation-data-menu-styles"
                    className="ti-form-radio"
                    id="switcher-menu-click"
                    checked={theme.dataNavStyle == 'menu-click'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Menuclick(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-menu-click"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Menu Click
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="navigation-data-menu-styles"
                    className="ti-form-radio"
                    id="switcher-menu-hover"
                    checked={theme.dataNavStyle == 'menu-hover'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.MenuHover(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-menu-hover"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Menu Hover
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="navigation-data-menu-styles"
                    className="ti-form-radio"
                    id="switcher-icon-click"
                    checked={theme.dataNavStyle == 'icon-click'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.IconClick(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-icon-click"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Icon Click
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="navigation-data-menu-styles"
                    className="ti-form-radio"
                    id="switcher-icon-hover"
                    checked={theme.dataNavStyle == 'icon-hover'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.IconHover(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-icon-hover"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Icon Hover
                  </label>
                </div>
              </div>
              <div className="px-4 text-xs text-secondary">
                <b className="me-2">Note:</b>Works same for both Vertical and Horizontal
              </div>
            </div>
            <div className="sidemenu-layout-styles">
              <p className="switcher-style-head">Sidemenu Layout Syles:</p>
              <div className="switcher-style grid grid-cols-2 gap-2">
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-default-menu"
                    defaultChecked
                    onChange={_e => {}}
                    onClick={() => switcherdata.Defaultmenu(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-default-menu"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Default Menu
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-closed-menu"
                    checked={theme.dataVerticalStyle == 'closed'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Closedmenu(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-closed-menu"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Closed Menu
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-icontext-menu"
                    checked={theme.dataVerticalStyle == 'icontext'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.iconTextfn(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-icontext-menu"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Icon Text
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-icon-overlay"
                    onClick={() => switcherdata.iconOverayFn(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-icon-overlay"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Icon Overlay
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-detached"
                    checked={theme.dataVerticalStyle == 'detached'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.DetachedFn(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-detached"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Detached
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="sidemenu-layout-styles"
                    className="ti-form-radio"
                    id="switcher-double-menu"
                    checked={theme.dataVerticalStyle == 'doublemenu'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.DoubletFn(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-double-menu"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Double Menu
                  </label>
                </div>
              </div>
              <div className="px-4 text-xs text-secondary">
                <b className="me-2">Note:</b>Navigation menu styles won&apos;t work here.
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Page Styles:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex">
                  <input
                    type="radio"
                    name="data-page-styles"
                    className="ti-form-radio"
                    id="switcher-regular"
                    checked={theme.dataPageStyle == 'regular'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Regular(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-regular"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Regular
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="data-page-styles"
                    className="ti-form-radio"
                    id="switcher-classic"
                    checked={theme.dataPageStyle == 'classic'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Classic(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-classic"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Classic
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="data-page-styles"
                    className="ti-form-radio"
                    id="switcher-modern"
                    checked={theme.dataPageStyle == 'modern'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Modern(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-modern"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    {' '}
                    Modern
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Layout Width Styles:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex">
                  <input
                    type="radio"
                    name="layout-width"
                    className="ti-form-radio"
                    id="switcher-full-width"
                    checked={theme.dataWidth == 'fullwidth'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Fullwidth(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-full-width"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    FullWidth
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="layout-width"
                    className="ti-form-radio"
                    id="switcher-boxed"
                    checked={theme.dataWidth == 'boxed'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Boxed(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-boxed"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Boxed
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Menu Positions:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex">
                  <input
                    type="radio"
                    name="data-menu-positions"
                    className="ti-form-radio"
                    id="switcher-menu-fixed"
                    checked={theme.dataMenuPosition == 'fixed'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.FixedMenu(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-menu-fixed"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Fixed
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="data-menu-positions"
                    className="ti-form-radio"
                    id="switcher-menu-scroll"
                    checked={theme.dataMenuPosition == 'scrollable'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.scrollMenu(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-menu-scroll"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Scrollable{' '}
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p className="switcher-style-head">Header Positions:</p>
              <div className="switcher-style grid grid-cols-3">
                <div className="flex">
                  <input
                    type="radio"
                    name="data-header-positions"
                    className="ti-form-radio"
                    id="switcher-header-fixed"
                    checked={theme.dataHeaderPosition == 'fixed'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Headerpostionfixed(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-header-fixed"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Fixed
                  </label>
                </div>
                <div className="flex">
                  <input
                    type="radio"
                    name="data-header-positions"
                    className="ti-form-radio"
                    id="switcher-header-scroll"
                    checked={theme.dataHeaderPosition == 'scrollable'}
                    onChange={_e => {}}
                    onClick={() => switcherdata.Headerpostionscroll(ThemeChanger)}
                  />
                  <label
                    htmlFor="switcher-header-scroll"
                    className="ms-2 text-defaultsize font-semibold text-defaulttextcolor dark:text-defaulttextcolor/70"
                  >
                    Scrollable
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div id="switcher-2" className="hidden" role="tabpanel" aria-labelledby="switcher-item-2">
            <div className="theme-colors">
              <p className="switcher-style-head">Menu Colors:</p>
              <div className="switcher-style flex space-x-3 rtl:space-x-reverse">
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-white"
                    type="radio"
                    name="menu-colors"
                    checked={theme.dataMenuStyles == 'light'}
                    onChange={_e => {}}
                    id="switcher-menu-light"
                    onClick={() => switcherdata.lightMenu(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Light Menu
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-dark"
                    type="radio"
                    name="menu-colors"
                    checked={theme.dataMenuStyles == 'dark'}
                    onChange={_e => {}}
                    id="switcher-menu-dark"
                    onClick={() => switcherdata.darkMenu(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Dark Menu
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-primary"
                    type="radio"
                    name="menu-colors"
                    checked={theme.dataMenuStyles == 'color'}
                    onChange={_e => {}}
                    id="switcher-menu-primary"
                    onClick={() => switcherdata.colorMenu(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Color Menu
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-gradient"
                    type="radio"
                    name="menu-colors"
                    checked={theme.dataMenuStyles == 'gradient'}
                    onChange={_e => {}}
                    id="switcher-menu-gradient"
                    onClick={() => switcherdata.gradientMenu(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Gradient Menu
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-transparent"
                    type="radio"
                    name="menu-colors"
                    checked={theme.dataMenuStyles == 'transparent'}
                    onChange={_e => {}}
                    id="switcher-menu-transparent"
                    onClick={() => switcherdata.transparentMenu(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Transparent Menu
                  </span>
                </div>
              </div>
              <div className="px-4 text-[.6875rem] text-[#8c9097] dark:text-white/50">
                <b className="me-2">Note:</b>If you want to change color Menu dynamically change from below Theme
                Primary color picker.
              </div>
            </div>
            <div className="theme-colors">
              <p className="switcher-style-head">Header Colors:</p>
              <div className="switcher-style flex space-x-3 rtl:space-x-reverse">
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-white !border"
                    type="radio"
                    name="header-colors"
                    checked={theme.dataHeaderStyles == 'light'}
                    onChange={_e => {}}
                    id="switcher-header-light"
                    onClick={() => switcherdata.lightHeader(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Light Header
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-dark"
                    type="radio"
                    name="header-colors"
                    checked={theme.dataHeaderStyles == 'dark'}
                    onChange={_e => {}}
                    id="switcher-header-dark"
                    onClick={() => switcherdata.darkHeader(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Dark Header
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-primary"
                    type="radio"
                    name="header-colors"
                    checked={theme.dataHeaderStyles == 'color'}
                    onChange={_e => {}}
                    id="switcher-header-primary"
                    onClick={() => switcherdata.colorHeader(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Color Header
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-gradient"
                    type="radio"
                    name="header-colors"
                    checked={theme.dataHeaderStyles == 'gradient'}
                    onChange={_e => {}}
                    id="switcher-header-gradient"
                    onClick={() => switcherdata.gradientHeader(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Gradient Header
                  </span>
                </div>
                <div className="hs-tooltip ti-main-tooltip ti-form-radio switch-select">
                  <input
                    className="hs-tooltip-toggle ti-form-radio color-input color-transparent"
                    type="radio"
                    checked={theme.dataHeaderStyles == 'transparent'}
                    onChange={_e => {}}
                    name="header-colors"
                    id="switcher-header-transparent"
                    onClick={() => switcherdata.transparentHeader(ThemeChanger)}
                  />
                  <span
                    className="hs-tooltip-content ti-main-tooltip-content !bg-black !px-2 !py-1 text-xs font-medium !text-white shadow-sm dark:!bg-black"
                    role="tooltip"
                  >
                    Transparent Header
                  </span>
                </div>
              </div>
              <div className="px-4 text-[.6875rem] text-[#8c9097] dark:text-white/50">
                <b className="me-2">Note:</b>If you want to change color Header dynamically change from below Theme
                Primary color picker.
              </div>
            </div>
            <div className="theme-colors">
              <p className="switcher-style-head">Theme Primary:</p>
              <div className="switcher-style flex space-x-3 rtl:space-x-reverse">
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-primary-1"
                    type="radio"
                    name="theme-primary"
                    checked={theme.colorPrimaryRgb == '58, 88, 146'}
                    onChange={_e => {}}
                    id="switcher-primary"
                    onClick={() => switcherdata.primaryColor1(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-primary-2"
                    type="radio"
                    name="theme-primary"
                    checked={theme.colorPrimaryRgb == '92, 144 ,163'}
                    onChange={_e => {}}
                    id="switcher-primary1"
                    onClick={() => switcherdata.primaryColor2(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-primary-3"
                    type="radio"
                    name="theme-primary"
                    checked={theme.colorPrimaryRgb == '161, 90 ,223'}
                    onChange={_e => {}}
                    id="switcher-primary2"
                    onClick={() => switcherdata.primaryColor3(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-primary-4"
                    type="radio"
                    name="theme-primary"
                    checked={theme.colorPrimaryRgb == '78, 172, 76'}
                    onChange={_e => {}}
                    id="switcher-primary3"
                    onClick={() => switcherdata.primaryColor4(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-primary-5"
                    type="radio"
                    name="theme-primary"
                    checked={theme.colorPrimaryRgb == '223, 90, 90'}
                    onChange={_e => {}}
                    id="switcher-primary4"
                    onClick={() => switcherdata.primaryColor5(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select color-primary-light mt-1 ps-0">
                  <div className="theme-container-primary">
                    <button className="">nano</button>
                  </div>
                  <div className="pickr-container-primary">
                    <div className="pickr">
                      <button
                        className="pcr-button"
                        onClick={(ele: any) => {
                          if (ele.target.querySelector('input')) {
                            ele.target.querySelector('input').click();
                          }
                        }}
                      >
                        <Themeprimarycolor theme={theme} actionfunction={ThemeChanger} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="theme-colors">
              <p className="switcher-style-head">Theme Background:</p>
              <div className="switcher-style flex space-x-3 rtl:space-x-reverse">
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-bg-1"
                    type="radio"
                    name="theme-background"
                    checked={theme.bodyBg == '34 44 110'}
                    onChange={_e => {}}
                    id="switcher-background"
                    onClick={() => switcherdata.backgroundColor1(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-bg-2"
                    type="radio"
                    name="theme-background"
                    checked={theme.bodyBg == '22 92 129'}
                    onChange={_e => {}}
                    id="switcher-background1"
                    onClick={() => switcherdata.backgroundColor2(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-bg-3"
                    type="radio"
                    name="theme-background"
                    checked={theme.bodyBg == '104 51 149'}
                    onChange={_e => {}}
                    id="switcher-background2"
                    onClick={() => switcherdata.backgroundColor3(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-bg-4"
                    type="radio"
                    name="theme-background"
                    checked={theme.bodyBg == '29 106 56'}
                    onChange={_e => {}}
                    id="switcher-background3"
                    onClick={() => switcherdata.backgroundColor4(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio color-input color-bg-5"
                    type="radio"
                    name="theme-background"
                    checked={theme.bodyBg == '134 80 34'}
                    onChange={_e => {}}
                    id="switcher-background4"
                    onClick={() => switcherdata.backgroundColor5(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select color-bg-transparent mt-1 ps-0">
                  <div className="theme-container-background">
                    <button className="">nano</button>
                  </div>
                  <div className="pickr-container-background">
                    <div className="pickr">
                      <button
                        className="pcr-button"
                        onClick={(ele: any) => {
                          if (ele.target.querySelector('input')) {
                            ele.target.querySelector('input').click();
                          }
                        }}
                      >
                        <switcherdata.Themebackgroundcolor />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-image theme-colors">
              <p className="switcher-style-head">Menu With Background Image:</p>
              <div className="switcher-style flex flex-wrap gap-3 space-x-3 rtl:space-x-reverse">
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio bgimage-input bg-img1"
                    type="radio"
                    name="theme-images"
                    id="switcher-bg-img"
                    onClick={() => switcherdata.bgImage1(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio bgimage-input bg-img2"
                    type="radio"
                    name="theme-images"
                    id="switcher-bg-img1"
                    onClick={() => switcherdata.bgImage2(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio bgimage-input bg-img3"
                    type="radio"
                    name="theme-images"
                    id="switcher-bg-img2"
                    onClick={() => switcherdata.bgImage3(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio bgimage-input bg-img4"
                    type="radio"
                    name="theme-images"
                    id="switcher-bg-img3"
                    onClick={() => switcherdata.bgImage4(ThemeChanger)}
                  />
                </div>
                <div className="ti-form-radio switch-select">
                  <input
                    className="ti-form-radio bgimage-input bg-img5"
                    type="radio"
                    name="theme-images"
                    id="switcher-bg-img4"
                    onClick={() => switcherdata.bgImage5(ThemeChanger)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ti-offcanvas-footer justify-between sm:flex">
          <Link
            to="#"
            onClick={() => switcherdata.Reset(ThemeChanger)}
            id="reset-all"
            className="ti-btn ti-btn-danger-full m-1 w-full"
          >
            Reset
          </Link>{' '}
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state: any) => ({
  local_varaiable: state.theme,
});

// @ts-expect-error - temporary ignore
export default connect(mapStateToProps, {ThemeChanger})(Switcher);
